import { ParsedTimeslot } from './timeslots';

export interface TimeslotInterval {
  price: number;
  timeslots: ParsedTimeslot[];
  isBlockedByMinimumNotice: boolean;
}

const arrangeInIntervals = (timeslots: ParsedTimeslot[]) => {
  if (timeslots.length === 0) {
    return [];
  }
  const intervals: TimeslotInterval[] = [
    {
      price: timeslots[0].price,
      timeslots: [timeslots[0]],
      isBlockedByMinimumNotice: timeslots[0].isBlockedByMinimumNotice,
    },
  ];

  if (timeslots.length === 1) {
    return intervals;
  }

  timeslots.slice(1).forEach((timeslot) => {
    const currentInterval = intervals[intervals.length - 1];
    if (
      currentInterval.isBlockedByMinimumNotice === timeslot.isBlockedByMinimumNotice &&
      timeslot.price === currentInterval.price
    ) {
      currentInterval.timeslots.push(timeslot);
    } else {
      intervals.push({
        price: timeslot.price,
        timeslots: [timeslot],
        isBlockedByMinimumNotice: timeslot.isBlockedByMinimumNotice,
      });
    }
  });

  console.log('arrangeInIntervals intervals', intervals);

  return intervals;
};

export default arrangeInIntervals;
